<template>
  <div class="row">
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" :color="color" loader="dots" />
    <div class="col-12 f13">
      <div class="card concard card-shadow">
        <div class="card-header white text-center">
          <img src="@/assets/logo.png" style="height: 100px" alt="..." />
          <div class="t1" style="margin: 5px">ข้อมูลที่พักอาศัย</div>
        </div>
        <Form @submit="onSubmitRegister" :validation-schema="register" id="kt_account_profile_details_form" class="form"
          novalidate="novalidate">
          <div class="card-body mb-47 mt-2 white">
            <!--begin::Card body-->
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <!--begin::Input group-->
                  <div class="row mb-6">
                    <!--begin::Label-->
                    <label class="col-lg-4 col-form-label required fw-bold fs-6">บ้านเลขที่</label>
                    <!--end::Label-->

                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <Field type="text" name="numberhome" class="form-control form-control-solid"
                        placeholder="บ้านเลขที่" v-model="data_register.numberhome" />
                      <div class="fv-plugins-message-container">
                        <div class="fv-help-block">
                          <ErrorMessage name="numberhome" />
                        </div>
                      </div>
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                </div>
                <div class="col-6">
                  <!--begin::Input group-->
                  <div class="row mb-6">
                    <!--begin::Label-->
                    <label class="col-lg-4 col-form-label fw-bold fs-6">หมู่</label>
                    <!--end::Label-->

                    <!--begin::Col-->
                    <div class="col-lg-8 fv-row">
                      <Field type="text" name="moo" class="form-control form-control-solid" placeholder="หมู่"
                        v-model="data_register.moo" />
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Input group-->
                </div>
              </div>

              <!--begin::Input group-->
              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label fw-bold fs-6">ตรอก/ซอย</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field type="text" name="alleyway" class="form-control form-control-solid" placeholder="ตรอก/ซอย"
                    v-model="data_register.alleyway" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="alleyway" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label fw-bold fs-6">ถนน</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field type="text" name="road" class="form-control form-control-solid" placeholder="ถนน"
                    v-model="data_register.road" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="road" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label required fw-bold fs-6">จังหวัด</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field name="province" class="form-control form-control-solid" as="select"
                    v-model="data_register.province">
                    <option value="" selected disabled>โปรดเลือก</option>
                    <option value="ระยอง">ระยอง</option>
                    <option v-for="(item, key) in uniqueProvince" :key="key" :value="key">
                      {{ item.province }}
                    </option>
                    <!--:selected="value && value.includes(role.id)"-->
                  </Field>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="province" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label required fw-bold fs-6">อำเภอ</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field name="amphoe" class="form-control form-control-solid" as="select" v-model="data_register.amphoe">
                    <option value="" selected disabled>โปรดเลือก</option>
                    <option v-for="(item, key) in uniqueAmphoe" :key="key" :value="key">
                      {{ item.amphoe }}
                    </option>
                    <!--:selected="value && value.includes(role.id)"-->
                  </Field>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="amphoe" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label required fw-bold fs-6">ตำบล</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field name="district" class="form-control form-control-solid" as="select"
                    v-model="data_register.district">
                    <option value="" selected disabled>โปรดเลือก</option>

                    <option v-for="(item, key) in uniqueDistrict" :key="key" :value="key">
                      {{ item.district }}
                    </option>
                    <!--:selected="value && value.includes(role.id)"-->
                  </Field>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="district" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Input group-->


              <div class="row mb-6">
                <label class="col-lg-4 col-form-label required fw-bold fs-6">ชุมชน</label>

                <div class="col-lg-8 fv-row">
                  <Field name="community" class="form-control form-control-solid" as="select" @change="checkCom($event)"
                    v-model="data_register.community">
                    <option value="" selected disabled>โปรดเลือก</option>
                    <option value="เกาะกลอย">
                      เกาะกลอย
                    </option>
                    <option value="ชายกระป่อม">
                      ชายกระป่อม
                    </option>
                    <option value="พูนไฉ่">
                      พูนไฉ่
                    </option>
                    <option value="ตีนเนิน – เกาะหวาย">
                      ตีนเนิน – เกาะหวาย
                    </option>
                    <option value="แขวงการทาง">
                      แขวงการทาง
                    </option>
                    <option value="หนองสนม – ปักป่า">
                      หนองสนม – ปักป่า
                    </option>
                    <option value="วัดป่าประดู่ 1">
                      วัดป่าประดู่ 1
                    </option>
                    <option value="วัดป่าประดู่ 2">
                      วัดป่าประดู่ 2
                    </option>
                    <option value="ศูนย์การค้า">
                      ศูนย์การค้า
                    </option>

                    <option value="ก้นปึก – ปากคลอง">
                      ก้นปึก – ปากคลอง
                    </option>

                    <option value="ข้างอำเภอ – ทางไผ่">
                      ข้างอำเภอ – ทางไผ่
                    </option>

                    <option value="ริมน้ำ – ท่าเกตุ">
                      ริมน้ำ – ท่าเกตุ
                    </option>
                    <option value="สมเด็จพระเจ้าตากสินฯ">
                      สมเด็จพระเจ้าตากสินฯ
                    </option>
                    <option value="หลังวัดโขดทิมทาราม">
                      หลังวัดโขดทิมทาราม
                    </option>
                    <option value="สะพานราษฎร์">
                      สะพานราษฎร์
                    </option>
                    <option value="สวนวัดโขดทิมทาราม">
                      สวนวัดโขดทิมทาราม
                    </option>
                    <option value="บางจาก">
                      บางจาก
                    </option>
                    <option value="ทุ่งโตนด">
                      ทุ่งโตนด
                    </option>
                    <option value="เนินพระ">
                      เนินพระ
                    </option>
                    <option value="มุสลิม – ปากคลอง">
                      มุสลิม – ปากคลอง
                    </option>
                    <option value="สนามเป้า">
                      สนามเป้า
                    </option>
                    <option value="บ้านปากคลอง">
                      บ้านปากคลอง
                    </option>
                    <option value="สัมฤทธิ์">
                      สัมฤทธิ์
                    </option>
                    <option value="สมุทรเจดีย์">
                      สมุทรเจดีย์
                    </option>
                    <option value="ปากน้ำ 1">
                      ปากน้ำ 1
                    </option>
                    <option value="ปากน้ำ 2">
                      ปากน้ำ 2
                    </option>
                    <option value="แหลมรุ่งเรือง">
                      แหลมรุ่งเรือง
                    </option>
                    <option value="นอกพื้นที่">
                      นอกพื้นที่
                    </option>
                  </Field>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="community" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-8 fv-row mt-1" v-if="community_status">
                  <Field type="text" name="community_other" class="form-control form-control-solid" placeholder="ระบุ"
                    v-model="data_register.community_other" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="community_other" />
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>
          <div class="card-footer white">
            <div class="d-flex justify-center align-center">
              <div style="width: 100%; padding: 0px 5px">
                <button type="button" @click="back" class="button btn-back">
                  ย้อนกลับ
                </button>
              </div>
              <div style="width: 100%; padding: 0px 5px">
                <button type="submit" style="width: 100%" class="button">
                  ลงทะเบียน
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, onMounted, inject, computed } from "vue";
import { SET_REGISTER } from "@/store/modules/RegisterModel";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import json from "@/service/DataStore.json";
import useRegister from "@/service/api/register";
import useSweetalert from "@/service/sweetalert2";
import liff from "@line/liff";
export default defineComponent({
  name: "Register",
  components: {
    ErrorMessage,
    Field,
    Form,
    Loading,
  },
  setup() {
    const store = inject("store");
    const router = inject("router");
    const { Sconfirm, SconfirmNc, SToast } = useSweetalert();
    const { Register } = useRegister();
    const items = ref(json);
    let isLoading = ref(false);
    let color = ref(process.env.VUE_APP_COLOR);
    const data_register = store.getters.getRegister;

    let community_status = ref(false);


    function checkCom(event) {
      if (event.target.value === "นอกพื้นที่") {
        community_status.value = true;
      } else {
        community_status.value = false;
      }
    }

    const register = Yup.object().shape({
      numberhome: Yup.string().required("กรุณากรอก บ้านเลขที่"),
      province: Yup.string().required("กรุณาเลือก จังหวัด"),
      amphoe: Yup.string().required("กรุณาเลือก อำเภอ"),
      district: Yup.string().required("กรุณาเลือก ตำบล"),
      //school: Yup.string().required("กรุณาเลือก โรงเรียน"),
      community: Yup.string().required("กรุณาเลือก ชุมชน"),
      community_other: Yup.string()
        .when("community", {
          is: (community) => community === "นอกพื้นที่",
          then: Yup.string().required("กรุณากรอก ชุมชน"),
        }),
    });

    // const uniqueProvince = computed(() => {
    //   return items.value.reduce((seed, current) => {
    //     return Object.assign(seed, {
    //       [current.province]: current,
    //     });
    //   }, {});
    // });

    const uniqueProvince = computed(() => {
      return items.value.reduce((seed, current) => {
        let sount_province = ['ระยอง'];
        if (sount_province.includes(current.province)) {
          console.log('match');
        }
        return Object.assign(seed, {
          [current.province]: current,
        });

      }, {});
    });

    const uniqueAmphoe = computed(() => {
      let dd = items.value.filter(
        (item) => item.province === data_register.province
      );
      return dd.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.amphoe]: current,
        });
      }, {});
    });

    const uniqueDistrict = computed(() => {
      let dd = items.value.filter(
        (item) => item.amphoe === data_register.amphoe
      );
      return dd.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.district]: current,
        });
      }, {});
    });

    const back = () => {
      router.push({ name: "Register_1" });
    };

    onMounted(() => {
      if (!store.getters.getAccessToken.accesstoken) {
        router.push({ name: "Home" });
      }
    });

    const onSubmitRegister = (values) => {
      store.dispatch(SET_REGISTER, values);

      Sconfirm("ยืนยัน การลงทะเบียน", "question").then(async (result) => {
        if (result.isConfirmed) {
          isLoading.value = true;

          await Register(store.getters.getRegister)
            .then((result) => {
              isLoading.value = false;
              if (result.data.status === "success") {
                SconfirmNc("ลงทะเบียนสำเร็จ", "success", "ตกลง").then(() => {
                  if (store.getters.getUrlCallBack.id) {
                    liff.ready.then(() => {
                      liff.openWindow({
                        url: store.getters.getUrlCallBack.id,
                        external: false,
                      });
                    });
                  } else {
                    router.push({ name: "Home" });
                  }
                });
              } else {
                SconfirmNc("ไม่มีสิทธิ์เข้าใช้งาน", "error", "ตกลง").then(
                  () => {
                    liff.ready.then(() => {
                      liff.closeWindow();
                    });
                  }
                );
              }
            })
            .catch(() => {
              SToast("error", "เกิดข้อผิดผาด กรุณาลองใหม่อีกครั้ง");
            });
        }
      });
    };

    return {
      back,
      onSubmitRegister,
      register,
      data_register,
      isLoading,
      color,
      uniqueProvince,
      uniqueAmphoe,
      uniqueDistrict,
      checkCom,
      community_status
    };
  },
});
</script>

<style scoped>
.icon {
  width: 50px;
  padding: 5px;
}

.gender {
  padding: 30px 20px;
  border: 1px solid #dee2e6;
}

input[type="radio"] {
  display: none;
}

input:checked+span {
  color: var(--color);
  border: 2px solid var(--color);
}
</style>
